export const TOKEN = "TOKEN";

export const siteName = "까비";

export const defaultCoverImg =
  "https://cabia-upload-bucket.s3.amazonaws.com/1624674856418background_basic.png";
export const defaultMenuImg =
  "https://cabia-upload-bucket.s3.amazonaws.com/1628765054285menu_basic.png";
export const defaultProfileImg =
  "https://cabia-upload-bucket.s3.amazonaws.com/1624674877543user_basic.png";
